<template>
  <div class="content-panel">
    <!--    <a-input-search-->
    <!--      v-model="subcompanyname"-->
    <!--      style="margin-bottom: 8px"-->
    <!--      placeholder="请输入设备参数"-->
    <!--      @search="queryDictData"-->
    <!--      @pressEnter="queryDictData"-->
    <!--      v-if="showSearch"-->
    <!--    />-->
    <!--    <a-input-search style="margin-bottom: 8px" placeholder="Search" @change="onChange" />-->
    <div class="deptBtn" v-if="$auth('centralizedDeptManagement.save')">
      <a-button type="primary" @click="upDataDeptHasBeenConfiguredList" :loading="btnLoading">保存</a-button>
    </div>
    <a-spin :spinning="loading" wrapperClassName="centralizedDeptSpin" :class="[!$auth('centralizedDeptManagement.save') ? 'height100' : '' ]">
      <a-card :bordered="false">
        <!--默认展开的-->
        <!--        :defaultExpandedKeys="defaultSelectedKeys"-->
<!--        :checkStrictly="true"-->
        <a-tree
          ref="tree"
          :treeData="treeData"
          checkable
          :checkStrictly="true"
          :autoExpandParent="autoExpandParent"
          @check="onCheck"
          @expand="onExpand"
          v-model="checkedKeys"
          :expandedKeys="expandedKeys"
        >
          <template slot="custom" slot-scope="record">
            <span class="title-name">{{ record.subcompanyname }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getCompanyTree } from '@/api/organizationalStructure'
import { getDeptHasBeenConfigured, upDataDeptHasBeenConfigured } from '@/api/centralizedDeptManagement'

export default {
  name: 'OrgTree',
  components: {
  },
  props: ['isOut', 'showSearch'],
  data () {
    return {
      loading: false,
      btnLoading: false,
      subcompanyname: '',
      treeData: [],
      treeDataOrg: [],
      defaultSelectedKeys: [],
      selectedKeys: [0],
      selectedData: {},
      autoExpandParent: true,
      checkedKeys: {
        checked: [],
        halfChecked: []
      },
      expandedKeys: [],
      dataList: [],
      gData: []
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  async mounted () {
    await this.initTree()
    await this.getDeptHasBeenConfiguredList()
  },
  methods: {
    ...mapActions(['handleTypeCode']),
    generateList (data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i]
        this.dataList.push(node)
        if (node.children) {
          this.generateList(node.children)
        }
      }
    },
    getParentKey (key, tree) {
      let parentKey
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children)
          }
        }
      }
      return parentKey
    },
    onChange (e) {
      const value = e.target.value
      if (value === '') {
        this.expandedKeys = []
        this.treeData = this.treeDataOrg
        return
      }
      const treeData = []
      this.expandedKeys = this.dataList.map(item => {
        if (item.subcompanyname.indexOf(value) > -1) {
          treeData.push(item)
          return this.getParentKey(item.key, this.treeDataOrg)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      this.treeData = treeData
    },
    // 树结构
    async initTree () {
      this.loading = true
      const data = {
        isAsset: true,
        paging: false
      }
      const res = await getCompanyTree(data)
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            // do
            data[i].scopedSlots = {
              title: 'custom'
            }
            if (data[i].type === 1) {
              data[i].key = data[i].key + 'type1'
              data[i].disabled = true
            } else {
              data[i].disabled = false
            }
            if (data[i].children.length) {
              loop(data[i].children)
            }
          }
        }
        loop(res.data)
        this.generateList(res.data)
        this.treeData = res.data
        this.treeDataOrg = res.data
      }
      this.loading = false
    },
    // 获取已配置的部门
    getDeptHasBeenConfiguredList () {
      getDeptHasBeenConfigured().then(res => {
        if (res.status === 0) {
          this.checkedKeys.checked = res.data.map(item => {
            return item.key
          })
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    onCheck (checkedKeys, e) {
      this.checkedKeys = checkedKeys
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // 更新已配置的部门
    upDataDeptHasBeenConfiguredList () {
      this.btnLoading = true
      const data = []
      for (const item of this.checkedKeys.checked) {
        if (item.indexOf('type1') < 0) {
          data.push(
            {
              deptId: item.slice(0, item.indexOf('_'))
            }
          )
        }
      }
      upDataDeptHasBeenConfigured(data).then(res => {
        if (res.status === 0) {
          this.$emit('getUnConfiguredData')
          this.$message.success('保存成功')
          this.btnLoading = false
        } else {
          this.$message.error(res.info.message)
          this.btnLoading = false
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
          this.btnLoading = false
        })
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;
        .ant-tree-node-content-wrapper {
          margin-top: 8px !important;
        }
        .ant-tree-switcher {
          margin-top: 8px !important;
        }
        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-switcher_close{
          //margin-top: 8px !important;
          background: url('../../../../src/assets/icon-close.svg') no-repeat 5px 4px !important;
          svg{
            display: none !important;
          }
        }
        .ant-tree-switcher_open{
          //margin-top: 8px !important;
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.deptBtn {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.centralizedDeptSpin {
  height: calc(100% - 42px);
  overflow-y: auto;
  overflow-x: hidden;
  >.ant-spin-container {
    height: 100%;
    .ant-card {
      height: 100%;
      .ant-card-body {
        height: 100%;
        .ant-tree {
          height: 100%;
          overflow-x: hidden;
        }
      }
    }
  }
}
.height100 {
  height: 100%;
}
.treeCompanyName {
  font-size: 14px;
}
</style>
